module.exports = __webpack_public_path__ + "images/duin-599f536a8539694b799f06c41799e9ba.jpg";